import React, { PropsWithChildren, useContext } from "react";

import useFetchFeatureFlags from "hooks/api/featureFlags/useFetchFeatureFlags/useFetchFeatureFlags";
import { FeatureFlags } from "types/featureFlags";

export interface IFeatureFlagsContext {
  featureFlags: FeatureFlags;
  isLoading: boolean;
  isError: boolean;
}

export const FeatureFlagsContext = React.createContext<IFeatureFlagsContext>({
  featureFlags: {},
  isLoading: false,
  isError: false,
});

const FeatureFlagsContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { isLoading, data: featureFlagsData, isError } = useFetchFeatureFlags();
  const featureFlags = (featureFlagsData || {}) as FeatureFlags;

  return (
    <FeatureFlagsContext.Provider value={{ featureFlags, isLoading, isError }}>{children}</FeatureFlagsContext.Provider>
  );
};

export default FeatureFlagsContextProvider;

export const useFeatureFlags = (): IFeatureFlagsContext => {
  const context = useContext(FeatureFlagsContext);
  if (!context) {
    throw new Error("useFeatureFlags must be used within a FeatureFlagsProvider");
  }
  return context;
};
